import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=439e910c&scoped=true&"
import script from "./LeftSideBar.vue?vue&type=script&lang=js&"
export * from "./LeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e910c",
  null
  
)

export default component.exports